/** WebGL 1 shaders for the ocean-flow gradient (domain-warped noise + layered swells). */
export const FLOW_FRAG = `
precision mediump float;
uniform vec2 u_res; uniform float u_t; uniform vec2 u_m; uniform float u_mi;
uniform vec3 c1; uniform vec3 c2; uniform vec3 c3; uniform vec3 c4; uniform vec3 c5; uniform vec3 bg;
vec3 perm(vec3 x){ return mod(((x*34.0)+1.0)*x, 289.0); }
float snoise(vec2 v){
  const vec4 C = vec4(0.211324865405187, 0.366025403784439, -0.577350269189626, 0.024390243902439);
  vec2 i = floor(v + dot(v, C.yy)); vec2 x0 = v - i + dot(i, C.xx);
  vec2 i1 = (x0.x > x0.y) ? vec2(1.0, 0.0) : vec2(0.0, 1.0);
  vec4 x12 = x0.xyxy + C.xxzz; x12.xy -= i1; i = mod(i, 289.0);
  vec3 p = perm(perm(i.y + vec3(0.0, i1.y, 1.0)) + i.x + vec3(0.0, i1.x, 1.0));
  vec3 m = max(0.5 - vec3(dot(x0,x0), dot(x12.xy,x12.xy), dot(x12.zw,x12.zw)), 0.0); m = m*m; m = m*m;
  vec3 x = 2.0 * fract(p * C.www) - 1.0; vec3 h = abs(x) - 0.5; vec3 ox = floor(x + 0.5); vec3 a0 = x - ox;
  m *= 1.79284291400159 - 0.85373472095314 * (a0*a0 + h*h);
  vec3 g; g.x = a0.x * x0.x + h.x * x0.y; g.yz = a0.yz * x12.xz + h.yz * x12.yw;
  return 130.0 * dot(m, g);
}
float fbm(vec2 p){ float f = 0.0, a = 0.5; for (int i = 0; i < 3; i++){ f += a * snoise(p); p = p * 2.02 + 17.0; a *= 0.5; } return f; }
void main(){
  vec2 uv = gl_FragCoord.xy / u_res; vec2 p = uv; p.x *= u_res.x / u_res.y;
  float t = u_t;
  // pointer: a soft swell that pushes the water away from the cursor
  vec2 mp = u_m; mp.x *= u_res.x / u_res.y;
  vec2 d = p - mp; float fall = exp(-dot(d, d) * 5.0) * u_mi;
  p += normalize(d + 1e-4) * fall * 0.12;
  // domain warp → slow currents
  p *= 0.55;
  vec2 q = vec2(fbm(p + vec2(0.0, t * 0.035)), fbm(p + vec2(5.2, 1.3) - t * 0.03));
  float n = fbm(p * 0.9 + 1.2 * q + vec2(1.7, 9.2) + t * 0.025);
  // long, slow swells riding on the currents
  float sw  = 0.5 + 0.5 * sin(p.x * 3.2 + p.y * 1.6 + n * 2.4 + t * 0.32);
  float sw2 = 0.5 + 0.5 * sin(p.x * -1.9 + p.y * 2.8 + q.x * 2.6 - t * 0.24);
  vec3 col = mix(c1, c2, smoothstep(-0.55, 0.65, n));
  col = mix(col, c3, smoothstep(0.25, 1.0, sw) * 0.7);
  col = mix(col, c4, smoothstep(0.35, 1.0, sw2) * 0.6);
  col = mix(col, c5, smoothstep(0.15, 0.85, length(q)) * 0.3);
  // soft light on the crests
  col += pow(sw * sw2, 4.0) * 0.08 + fall * 0.05;
  gl_FragColor = vec4(col, 1.0);
}`;
export const FLOW_VERT = 'attribute vec2 a;void main(){gl_Position=vec4(a,0.0,1.0);}';
